import type { MonitoringPort } from '@/core/ports/external';
import { noopMonitoring } from './noop';
import { sentryMonitoring } from './sentry';
import { isSentryEnabled } from './env';

export function getMonitoringClient(): MonitoringPort {
  const runtime = typeof window === 'undefined' ? 'server' : 'client';
  if (isSentryEnabled(runtime)) {
    return sentryMonitoring;
  }
  return noopMonitoring;
}

export const monitoring = getMonitoringClient();
